import { createContext } from "react";

export const sbHeightCtx = createContext(null);
export const sbWidthCtx = createContext(null);
